// Initiates all logins to Parallel Markets by loading the Parallel Markets JS SDK
// and then asking for the profile info after account is connected

import { loadParallel } from "@parallelmarkets/vanilla";
import appsignal from "../appsignal";
import { isProd } from "../utils";

let parallel = null;

const ParallelMarketsHook = {
  mounted() {
    const authSuccess = (_authResponse, parallel) => {
      parallel.getProfile(
        (profile) => {
          this.pushEvent(
            "connect_parallel_v2",
            { profile },
            (_reply, _ref) => {},
          );
        },
        (error) => {
          this.pushEvent(
            "cancel_parallel",
            { error: error },
            (_reply, _ref) => {},
          );
        },
      );
    };

    const authFailure = (result) => {
      appsignal.sendError(result);

      this.pushEvent(
        "cancel_parallel",
        { error: result },
        (_reply, _ref) => {},
      );
    };

    const run = async () => {
      const client_id = process.env.ESBUILD_PARALLEL_MARKETS_CLIENT_ID;
      const environment = isProd ? "production" : "demo";

      if (parallel === null) {
        parallel = await loadParallel({
          client_id,
          environment,
          flow_type: "redirect",
          scopes: ["profile", "identity", "accreditation_status"],
          show_dismiss_button: true,
          verbose: true,
        });
      }

      parallel?.subscribeWithButton(
        (result) => authSuccess(result, parallel),
        (result) => authFailure(result),
      );
    };

    // the starting step for everyone -- show them the PM login button
    this.handleEvent("show_parallel_button", (_) => {
      run();
    });
  },
};

export default ParallelMarketsHook;
